import { render, staticRenderFns } from "./Chapter2.vue?vue&type=template&id=09dc4202&"
import script from "./Chapter2.vue?vue&type=script&lang=js&"
export * from "./Chapter2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports